export const SITE_NAME = "LexGo Invest";
export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL || "https://www.lexgoinvest.ai";
export const SITE_DESCRIPTION =
  "Investment opportunity in the LexGo family of AI-powered legal-tech products. Conducted under SEC Reg D Rule 506(c) to accredited investors only.";

// Nav order: Companies before Opportunity, intentionally. AIDirect, Inc.
// and LexGoAI, Inc. raise separately; an investor should understand the
// corporate structure before reading the offering terms.
export const NAV_LINKS = [
  { label: "Companies", href: "/companies" },
  { label: "Opportunity", href: "/opportunity" },
  { label: "Products", href: "/products" },
  { label: "Market", href: "/market" },
  { label: "Team", href: "/team" },
] as const;

export const FOOTER_LINKS = {
  opportunity: [
    { label: "Round Overview", href: "/opportunity" },
    { label: "Terms", href: "/terms" },
    { label: "Use of Funds", href: "/use-of-funds" },
    { label: "Financials", href: "/financials" },
    { label: "Market", href: "/market" },
  ],
  companies: [
    { label: "AIDirect, LLC", href: "/aidirect" },
    { label: "LexGoAI, LLC", href: "/lexgoai" },
    { label: "Corporate Separation", href: "/companies" },
    { label: "Team", href: "/team" },
  ],
  portfolio: [
    { label: "Products", href: "/products" },
    { label: "Services", href: "/services" },
    { label: "News", href: "/news" },
  ],
  legal: [
    { label: "Disclosures (506(c))", href: "/legal/disclosures" },
    { label: "Privacy Policy", href: "/legal/privacy" },
    { label: "Terms of Use", href: "/legal/terms" },
  ],
  connect: [
    { label: "Apply", href: "/apply" },
    { label: "Email", href: "mailto:invest@lexgoinvest.ai" },
  ],
} as const;

export const SAFE_HARBOR =
  "This page contains forward-looking statements within the meaning of the Private Securities Litigation Reform Act of 1995. Actual results may differ materially from those projected. See /legal/disclosures for full risk factors and the basis for any quantitative statement.";

export const REG_D_DISCLAIMER =
  "Securities offered under Reg D Rule 506(c) to accredited investors only. Not a solicitation in any jurisdiction where such offering is unlawful.";

export const INVESTOR_TYPES = [
  "Individual",
  "Joint (spouses)",
  "Self-directed IRA",
  "Entity (LLC, corp, partnership)",
  "Trust",
  "Investment fund",
] as const;

export const ACCREDITATION_METHODS = [
  "Income (>$200k individual or $300k joint, two most recent years)",
  "Net worth (>$1M excluding primary residence)",
  "Professional certification (Series 7, 65, or 82)",
  "Knowledgeable employee of issuer or affiliate",
  "Entity owned entirely by accredited investors",
  "Entity with >$5M in assets",
  "Written confirmation from CPA / attorney / RIA / broker-dealer",
] as const;

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","DC","FL","GA","HI","ID","IL","IN",
  "IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH",
  "NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT",
  "VT","VA","WA","WV","WI","WY","PR",
] as const;
